import { combineReducers } from 'redux';
import warehouseReducer from 'redux/warehouse/warehouseSlice';
import shiftReducer from 'redux/briefing/shiftSlice';
import briefingReducer from 'redux/briefing/briefingSlice'; 
import searchReducer from 'redux/briefing/archiveSearchSlice'; 
import KPIFilterReducer from 'redux/KPIs/filterSlice'; 
import KPIPeopleReducer from 'redux/KPIs/peopleSlice';
import KPINeoBonusCalculatorPeopleReducer from 'redux/KPIs/KPIPeopleSlice'; 
import KPIBonusPeriodSlice from 'redux/KPIs/bonusPeriodSlice';
import TerminalSlice from 'redux/warehouse/terminalSlice';
import laneSLice from 'redux/warehouse/lanesSlice';
import BusSlice from 'redux/logistics/busesSlice';
import activeBusessSlice from 'redux/logistics/activeBusesSlice';
import ordersSlice from 'redux/logistics/ordersSlice';
import pulseNavigationSlice from 'redux/pulse/navigationSlice';
import pulseB130ReportSlice from 'redux/pulse/B130ReportSlice';
import scraperOpsSlice from 'redux/scraperOperations/operationsSlice';

const rootReducer = combineReducers({
  warehouse: warehouseReducer,
  shift: shiftReducer,
  briefing: briefingReducer,
  archiveSearch: searchReducer,
  KPIFilterReducer: KPIFilterReducer,
  KPIPeopleReducer: KPIPeopleReducer,
  KPIBonusPeriodSlice: KPIBonusPeriodSlice,
  TerminalSlice: TerminalSlice,
  KPINeoBonusCalculatorPeopleReducer: KPINeoBonusCalculatorPeopleReducer,
  buses: BusSlice,
  activeBuses: activeBusessSlice,
  lanes: laneSLice,
  orders: ordersSlice,
  pulseNavigation: pulseNavigationSlice,
  pulseB130Report: pulseB130ReportSlice,
  scraperOperations: scraperOpsSlice,
});

export default rootReducer;
